var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "function-indicators" },
    [
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "function-indicators__wrapper" },
            [
              _vm._l(_vm.form.indicators, function (indicator) {
                return _c(
                  "div",
                  {
                    key: indicator.id,
                    staticClass: "function-indicators__item row",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col col-10 col-md-10 col-xl-10" },
                      [
                        _c("c-input", {
                          attrs: {
                            type: "select",
                            "floating-label": "Показатель",
                            searchable: true,
                            clearable: true,
                            items: _vm.collections.indicators,
                          },
                          model: {
                            value: indicator.value,
                            callback: function ($$v) {
                              _vm.$set(indicator, "value", $$v)
                            },
                            expression: "indicator.value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "function-indicators__item-actions col col-2 col-md-2 col-xl-2",
                      },
                      [
                        _c("c-button", {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover.blur.top",
                              value: "Удалить",
                              expression: "'Удалить'",
                              modifiers: { hover: true, blur: true, top: true },
                            },
                          ],
                          staticClass: "function-indicators__item-remove",
                          attrs: {
                            icon: { icon: "trash", color: "secondary" },
                            size: "iconic",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteIndicator(indicator.id)
                            },
                          },
                        }),
                        indicator &&
                        indicator.value &&
                        indicator.value.hasDescription
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "click blur",
                                    boundary: "window",
                                    content: "Показать описание",
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n            container: '#app',\n            trigger: 'click blur',\n            boundary: 'window',\n            content: 'Показать описание',\n            placement: 'top',\n          }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "function-indicators__item-description",
                              attrs: { size: "iconic", icon: "info-new" },
                              on: {
                                click: function ($event) {
                                  return _vm.showDescription(indicator)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              }),
              !_vm.form.indicators.length
                ? _c("p", { staticClass: "function-indicators__empty" }, [
                    _vm._v("Показателей пока не добавлено"),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col col-xl-12 col-md-12 col-12" },
                  [
                    _c("c-button", {
                      attrs: {
                        responsive: true,
                        size: "small",
                        label: "Добавить показатель",
                        icon: { icon: "plus", color: "primary" },
                        disabled: _vm.addIndicatorIsDisabled,
                      },
                      on: { click: _vm.addIndicator },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "function__actions",
                  class: { "function__actions--fixed": _vm.actionsIsFixed },
                },
                [
                  _c("c-button", {
                    staticClass: "function__action",
                    attrs: { label: "Отменить", size: "large" },
                    on: { click: _vm.onReset },
                  }),
                  _c("c-button", {
                    staticClass: "function__action",
                    attrs: {
                      label: "Сохранить",
                      size: "large",
                      color: "primary",
                    },
                    on: { click: _vm.onSubmit },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.isLoading
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.isLoading,
              height: "400",
            },
          })
        : _vm._e(),
      _c("m-description", { ref: "descriptionModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }